import { getAuthClient } from './auth';

const auth = getAuthClient();

export async function getApiData( request, communityNid ) {
  const {
    entityType,
    contentType,
    params,
    filter = [],
  } = request;
  const paramsString = new URLSearchParams( params ).toString();
  if ( communityNid ) {
    filter['og_audience.nid'] = communityNid;
  }
  const filterArray = [];
  if ( filter && Object.keys( filter ).length ) {
    Object.entries( filter ).forEach( ( [ key, value ] ) => {
      filterArray.push( `filter[${key}]=${value}` );
    } );
  }
  const filterRawString = filterArray.join( '&' );
  const filterString = filterRawString ? `${filterRawString}&` : '';
  const url = `/jsonapi/${entityType}/${contentType}?${filterString}${paramsString}`;
  const data = await auth.fetchWithAuthentication( url, 'GET', null );
  return data;
}

export async function getNormalizedApiData( request, communityNid = null, normalizeFunction ) {
  const data = await getApiData( request, communityNid );
  if(!data) return;
  const normalizedData = normalizeFunction( data );
  return normalizedData;
}

/**
 * @param {Object} request | Info about URL to fetch data from:
 * {
 *    entityType: {string}, // ex: 'node', 'taxonomy_term'
 *    contentType: {string}, // ex: 'photo_gallery', 'level_of_care'
 *    params: {object}, // ex: {
 *     include: {string}, // ex: 'field_cover_photo, field_gallery_photos'
 *    }
 *  }
 * @param {function} normalizeFunction | Function name that normalizes the data
 * @returns {Promise} | Resolves to normalized API data object
 */
export async function getNormalizedApiDataByUuid( request, normalizeFunction ) {
  const {
    entityType,
    contentType,
    uuid,
    params,
    fields,
  } = request;
  const paramsString = new URLSearchParams( params ).toString();
  const fieldsArray = [];
  // eslint-disable-next-line no-restricted-syntax
  if ( fields && Object.keys( fields ).length ) {
    Object.entries( fields ).forEach( ( [ key, value ] ) => {
      fieldsArray.push( `fields[${key}]=${value}` );
    } );
  }
  const fieldsRawString = fieldsArray.join( '&' );
  const fieldsString = fieldsRawString ? `&${fieldsRawString}` : '';
  const url = `/jsonapi/${entityType}/${contentType}/${uuid}/?${paramsString}${fieldsString}`;
  const data = await auth.fetchWithAuthentication( url, 'GET', null );
  const normalizedData = normalizeFunction( data );
  return normalizedData;
}